import { useContext, useEffect, useState } from "react";
import ILoadUserDTO from "../../../models/DTO/ILoadUserDTO";
import IOnUpdateUserSettingsDTO from "../../../models/DTO/IOnUpdateUserSettingsDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import "./OwThemeModeSwitcher.scss";
import UIService from "../../../services/UIService";
import UserService from "../../../services/UserService";
import IUpdateTokenSettingsDTO from "../../../models/DTO/IUpdateTokenSettingsDTO";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import UserContext from "../../../contexts/UserContext";
import VendorContext from "../../../contexts/VendorContext";
import SupplierContext from "../../../contexts/SupplierContext";
import UiContext from "../../../contexts/UiContext";
import { SocketContext } from "../../../contexts/SocketContext";

type Props = {};

export const OwThemeModeSwitcher = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const vendorModel = useContext(VendorContext);
    const uiContext = useContext(UiContext);
    const socket = useContext(SocketContext)!;

    const getTheme = () => {
        const { themeType } = UIService.getThemeType(supplierModel, userModel);

        return themeType.toUpperCase() === "LIGHT";
    };

    const [isLightMode, setIsLightMode] = useState(getTheme());
    const [hasLoaded, setHasLoaded] = useState(false);

    useEffect(() => {
        const currentTheme = UIService.isMainViewLight();

        if (hasLoaded) {
            updateTokenSettings();
        } else {
            setHasLoaded(true);
        }
    }, [isLightMode]);

    useEffect(() => {
        // Update the light mode state whenever the theme might change
        setIsLightMode(getTheme());
    }, [userModel, supplierModel]);

    const onUpdateTokenSettings = (data: IOnUpdateUserSettingsDTO) => {
        const payload: ILoadUserDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
        };

        socket.emit(EndpointsEnum.AppLoadUser, payload);

        const currentTheme = UIService.isMainViewLight();
    };

    const sockets: IUiSocketSetup[] = [{ endpoint: EndpointsEnum.TokenOnUpdateSettings, fn: onUpdateTokenSettings }];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        return () => {
            for (const _socket of sockets) {
                socket.removeListener(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    const updateTokenSettings = () => {
        const currentToken = UserService.getCurrentToken(userModel);

        if (currentToken) {
            const payload: IUpdateTokenSettingsDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                settings: {
                    theme: isLightMode ? "LIGHT" : "DARK",
                },
                tokenGuid: currentToken.guid,
            };

            socket.emit(EndpointsEnum.TokenUpdateSettings, payload);

            uiContext.setActivityIndicator(true);
        }
    };

    const toggleTheme = () => {
        setIsLightMode(!isLightMode);
    };

    let icon = "fad fa-moon";
    let mode = "dark";
    let title = "Dark Mode";

    if (isLightMode) {
        icon = "fad fa-sun";
        mode = "light";
        title = "Light Mode";
    }

    return (
        <div className={"OwThemeModeSwitcher " + mode}>
            <div className={"pointer toggle "} onClick={toggleTheme} title={title}>
                <i className={icon} />
            </div>
        </div>
    );
};
